module.exports = __webpack_public_path__ + "static/media/login_background.cf6b9945.jpg";